import styled from 'styled-components'
import { match } from 'ts-pattern'

import { CurrencyModel } from '@root/entities/currency'
import { CurrencyAmountCell } from '@root/entities/currency/ui/cells/currency-amount-cell'
import { CURRENCY_AMOUNT_NATIVE_PRESET } from '@root/shared/core/format'

import type { Pair } from '@root/entities/pair'
import type { Trade } from '@root/entities/trade'
import type { ClassNameProps } from '@root/shared/react'

type TradeTotalCellProps = {
  value: Trade.Trade
  pair: Pair.PairMinimal | undefined
  fixedCurrency: 'base' | 'usd' | 'native'
} & ClassNameProps

export const TradeTotalCell: React.FC<TradeTotalCellProps> = ({
  className,
  value,
  pair,
  fixedCurrency,
}) => {
  const currency = match(fixedCurrency)
    .with('base', () => {
      return pair?.base ?? CurrencyModel.nativeOf(value.network)
    })
    .with('usd', () => 'usd' as const)
    .with('native', () => CurrencyModel.nativeOf(value.network))
    .exhaustive()

  const total = match(fixedCurrency)
    .with('usd', () => value.totalUsd)
    .with('base', () => value.baseAmount)
    .with('native', () => value.totalNative)
    .exhaustive()

  return (
    <Root
      className={className}
      currency={currency}
      value={total}
      preset={CURRENCY_AMOUNT_NATIVE_PRESET}
    />
  )
}

const Root = styled(CurrencyAmountCell)`
  color: var(--row-color);
`
